<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelHistory.labelEdit')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.processingOrderNo') + ':'" prop="processingOrderNo">
            <el-input
              v-model.trim="form.processingOrderNo"
              name="processingOrderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.purchaseOrderNo') + ':'" prop="purchaseOrderNo">
            <el-input
              v-model.trim="form.purchaseOrderNo"
              name="purchaseOrderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialNo') + ':'" prop="materialNo">
            <el-input
              v-model.trim="form.materialNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.specificationNo') + ':'" prop="specificationNo">
            <el-input
              v-model.trim="form.specificationNo"
              name="specificationNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.deliveryDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count') + ':'" prop="count">
            <el-input
              v-model.trim.number="form.count"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.boxNo') + ':'" prop="boxNo">
            <el-input
              v-model.trim="form.boxNo"
              name="boxNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64">
              <template slot="prepend">#</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="historyLabelIFrameYuanHengDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="printYuanHengLabelFrame">{{$t('common.print')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          :loading="loading"
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import {
    validateCount,
  } from '@/utils/validate';
  import {
    initYuanHengLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';
  import {
    updateBox,
  } from '@/api/boxLabel';
  import {
    updateLabel,
  } from '@/api/label';

  export default {
    name: "YuanHengLabelDialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
      editRow: {
        type: Object,
        default: () => {},
      },
      isBoxLabel: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        form: {
          id: undefined,
          processingOrderNo: undefined,
          purchaseOrderNo: undefined,
          materialNo: undefined,
          specificationNo: undefined,
          deliveryDate: undefined,
          count: undefined,
          boxNo: undefined,
        },
        rules: {
          processingOrderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.processingOrderNoCanNotBeEmpty')
          }],
          purchaseOrderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.purchaseOrderNoCanNotBeEmpty')
          }],
          materialNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNoCanNotBeEmpty')
          }],
          specificationNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.specificationNoCanNotBeEmpty')
          }],
          deliveryDate: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
          count: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          boxNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('validate.boxNoCanNotBeEmpty')
          }],
        },
        loading: false,
      };
    },
    watch: {
      editRow(newValue) {
        if (newValue && Object.keys(newValue).length > 0 && this.visible === true) {
          const {
            id,
            processingOrderNo,
            purchaseOrderNo,
            customPartNo,
            partNo,
            dateCode,
            qty,
            reserve,
          } = newValue;
          this.form = {
            id: id,
            processingOrderNo,
            purchaseOrderNo,
            materialNo: customPartNo,
            specificationNo: partNo,
            deliveryDate: dateCode,
            count: qty,
            boxNo: reserve && reserve.startsWith('#') ? reserve.substring(1) : reserve,
          };
          setTimeout(() => {
            this.initYuanHengLabelFrame();
          }, 500);
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            if (this.isBoxLabel) {
              this.updateBox();
            } else {
              this.updateLabel();
            }
          }
        });
      },
      async updateBox() {
        const {
          id,
          processingOrderNo,
          purchaseOrderNo,
          materialNo,
          specificationNo,
          deliveryDate,
          count,
          boxNo,
        } = this.form;
        this.loading = true;
        const manufacturerLotNo = 'HZSX20160722';
        const dateCodeBatch = moment(deliveryDate).format('YYYYMMDD');
        const batchNo = `LOT/${processingOrderNo}/${purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${boxNo.replace('#', '')}`;
        try {
          await updateBox({
            boxLabelId: id,
            processingOrderNo,
            purchaseOrderNo,
            customPartNo: materialNo,
            partNo: specificationNo,
            dateCode: moment(deliveryDate).format('YYYY-MM-DD'),
            qty: count,
            reserve: '#' + boxNo,
            trackingNo: batchNo,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      async updateLabel() {
        const {
          id,
          processingOrderNo,
          purchaseOrderNo,
          materialNo,
          specificationNo,
          deliveryDate,
          count,
          boxNo,
        } = this.form;
        this.loading = true;
        const manufacturerLotNo = 'HZSX20160722';
        const dateCodeBatch = moment(deliveryDate).format('YYYYMMDD');
        const batchNo = `LOT/${processingOrderNo}/${purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${boxNo.replace('#', '')}`;
        try {
          await updateLabel({
            labelId: id,
            processingOrderNo,
            purchaseOrderNo,
            customPartNo: materialNo,
            partNo: specificationNo,
            dateCode: moment(deliveryDate).format('YYYY-MM-DD'),
            qty: count,
            reserve: '#' + boxNo,
            trackingNo: batchNo,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      initYuanHengLabelFrame() {
        const {
          processingOrderNo,
          purchaseOrderNo,
          materialNo,
          specificationNo,
          deliveryDate,
          count,
          boxNo,
        } = this.form;
        let iframe = document.getElementById('historyLabelIFrameYuanHengDialog');
        iframe = initYuanHengLabelFrame({
          iframe,
          processingOrderNo,
          purchaseOrderNo,
          materialNo,
          specificationNo,
          deliveryDate,
          count,
          boxNo: '#' + boxNo
        });
        iframe.contentWindow.document.close();
      },
      printYuanHengLabelFrame() {
        let iframe = document.getElementById('historyLabelIFrameYuanHengDialog');
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
